import {ComponentPropertiesPane} from '../components/NodePropertiesPane.jsx'
import LongText from '../../SidePanel/RightPanel/PropertiesControllerLongText.jsx'
import RadioGroup from '../../SidePanel/RightPanel/PropertiesControllerRadioGroup.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import Analyse from '../components/PropertiesControllerAnalyse.jsx'
//import ButtonClone from './PropertiesPaneButtonClone.jsx'
import ButtonDesign from './PropertiesPaneButtonDesign.jsx'
import ButtonPreview from './PropertiesPaneButtonPreview.jsx'
import DemoType from './DemoType.mjs'
import Model from './ModelUv.mjs'
import PageType from './PageType.mjs'
import UvType from './UvType.mjs'

const demoTypeOptions = DemoType.map(
    ([value, label, icon]) => ({icon, label, value})
)

const pageTypeOptions = PageType.map(
    ([value, label, icon]) => ({icon, label, value})
)

const uvTypeOptions = UvType.map(
    ([value, label, icon]) => ({icon, label, value})
)

const PropertiesPaneUv = (props) => (
    <ComponentPropertiesPane
        buttons={
            <>
                <ButtonDesign />
                <ButtonPreview />
            </>
        }

        controllers={
            <>
                <Text prop="uvName" />
                <Text prop="uvUserCode" />

                <RadioGroup
                    options={demoTypeOptions}
                    prop="demoType"
                />

                <RadioGroup
                    options={uvTypeOptions}
                    prop="uvType"
                />

                <RadioGroup
                    options={pageTypeOptions}
                    prop="pageType"
                />

                <LongText prop="memo" />
            </>
        }

        Model={Model}

        snSuffix={
            <Analyse
                modes={[
                    'ChgReferenceSingle',
                    'Reference',
                    'ReferenceCall',
                    'IsrfReference',
                ]}
            />
        }

        {...props}
    />
)

export default PropertiesPaneUv
